.d3{padding:0.5rem;}